
// import React, { useState, useEffect } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { MainLayout } from "../layout/MainLayout";

// const FeatureCard = ({
//   title,
//   description,
//   onClick,
//   status,
//   data,
//   isLoading,
// }) => {
//   return (
//     <div
//       onClick={onClick}
//       className={`bg-white rounded-lg p-5 shadow-sm hover:shadow-md transition-all duration-200 cursor-pointer
//         transform hover:-translate-y-1 border-l-4
//         ${
//           status === "active"
//             ? "border-green-500"
//             : status === "inactive"
//             ? "border-red-500"
//             : "border-transparent"
//         }`}
//     >
//       <div className="flex justify-between items-center mb-2">
//         <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
//         <span className="text-gray-500 text-xl">→</span>
//       </div>
//       <p className="text-sm text-gray-600 mb-4 leading-relaxed">
//         {description}
//       </p>
//       <div className="text-sm">
//         {isLoading ? (
//           <div className="flex items-center gap-2 text-gray-600">
//             <div className="w-4 h-4 border-2 border-gray-300 border-t-gray-600 rounded-full animate-spin"></div>
//             Loading status...
//           </div>
//         ) : status === "active" ? (
//           <div className="flex items-center gap-2 text-green-600">
//             <span className="font-bold">✓</span>
//             {data ? `Configured - ${data}` : "Configured"}
//           </div>
//         ) : (
//           <div className="flex items-center gap-2 text-red-600">
//             <span className="font-bold">!</span>
//             Not configured
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// const ProjectEdit = () => {
//   const navigate = useNavigate();
//   const { projectId } = useParams(); // Get project ID from URL parameters
//   const [featureData, setFeatureData] = useState({});
//   const [isLoading, setIsLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const token = localStorage.getItem("token");

//   const features = [
//     {
//       title: "Project Information",
//       description: "Configure basic project settings and general information",
//       path: `project/${projectId}`,
//       category: "Setup",
//     },
//     {
//       title: "3D Scene Setup",
//       description: "Upload and configure 3D models and scene parameters",
//       path: `scene-setup/${projectId}`,
//       category: "Setup",
//     },
//     {
//       title: "Window Configuration",
//       description: "Define and manage window properties and positions",
//       path: `window-setup/${projectId}`,
//       category: "Setup",
//     },
//     {
//       title: "Virtual Sensors",
//       description: "Configure virtual sensors for environmental monitoring",
//       path: `virtual-sensor-setup/${projectId}`,
//       category: "Simulation",
//     },
//     {
//       title: "Sensor Placement",
//       description: "Define optimal sensor locations and coverage areas",
//       path: `sensor-placement/${projectId}`,
//       category: "Simulation",
//     },
//     {
//       title: "Wind Gif Simulation",
//       description: "Set up and manage wind Gif simulation parameters",
//       path: `wind-gif/${projectId}`,
//       category: "Simulation",
//     },
//     {
//       title: "Wind Analysis",
//       description: "Set up and manage wind simulation parameters",
//       path: `virtual-wind/${projectId}`,
//       category: "Simulation",
//     },
//     {
//       title: "Solar Panel Setup",
//       description: "Configure PV panels and solar analysis settings",
//       path: `pv-panel-setup/${projectId}`,
//       category: "Energy",
//     },
//     {
//       title: "Room Heat Mapping",
//       description: "Set up thermal analysis and heat distribution",
//       path: `room-new/${projectId}`,
//       category: "Analysis",
//     },
//     {
//       title: "Building Profile",
//       description: "Update building profile information and files",
//       path: `file-manager/${projectId}`,
//       category: "Data",
//     },
//     // {
//     //   title: "File Setup",
//     //   description: "Manage and upload project files",
//     //   path: `pure-file-setup/${projectId}`,
//     //   category: "Data",
//     // },
//     {
//       title: "Technical Data",
//       description: "Configure technical specifications and parameters",
//       path: `technical-data/${projectId}`,
//       category: "Data",
//     },
//     {
//       title: "CRREM Data",
//       description: "Set up Carbon Risk Real Estate Monitor data",
//       path: `crrem-data-setup/${projectId}`,
//       category: "Sustainability",
//     },
//     {
//       title: "Wind Risk Analysis",
//       description: "Configure wind risk assessment parameters",
//       path: `wind-risk/${projectId}`,
//       category: "Risk Assessment",
//     },
//     {
//       title: "modernization and financial dashboard analysis",
//       description: "Configure wind risk assessment parameters",
//       path: `modernization/${projectId}`,
//       category: "Risk Assessment",
//     },
//     {
//       title: "Shading Analysis",
//       description: "Set up shading progression analysis",
//       path: `shading-progression/${projectId}`,
//       category: "Analysis",
//     },
//     {
//       title: "execution",
//       description: "Configure your execution",
//       path: `project-processing/${projectId}`,
//       category: "Analysis",
//     },
//     {
//       title: "Energy Dashboard",
//       description: "Configure energy monitoring dashboard",
//       path: `energy-dashboard-setup/${projectId}`,
//       category: "Energy",
//     },
//     // {
//     //   title: "Building Profile",
//     //   description: "Update building profile information and files",
//     //   path: `file-manager/${projectId}`,
//     //   category: "Setup",
//     // },
//   ];

//   useEffect(() => {
//     const fetchFeatureStatuses = async () => {
//       setIsLoading(true);
//       try {
//         const apiRoot = process.env.REACT_APP_API_ROOT;
//         const statuses = {};

//         for (const feature of features) {
//           try {
//             const response = await fetch(
//               `${apiRoot}/api/feature-status/${feature.path}`
//             );
//             const data = await response.json();
//             statuses[feature.title] = {
//               status: data.isConfigured ? "active" : "inactive",
//               data: data.summary,
//             };
//           } catch {
//             statuses[feature.title] = {
//               status: "inactive",
//               data: null,
//             };
//           }
//         }
//         setFeatureData(statuses);
//       } catch (err) {
//         setError("Failed to load feature statuses");
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     if (token && projectId) {
//       fetchFeatureStatuses();
//     }
//   }, [token, projectId, features]); // Add projectId as a dependency so it refetches when the URL changes

//   if (!token) {
//     return (
//       <MainLayout>
//         <div className="flex justify-center items-center p-8">
//           <div className="bg-red-50 text-red-700 px-4 py-3 rounded-md inline-block">
//             Please log in to access this page
//           </div>
//         </div>
//       </MainLayout>
//     );
//   }

//   const categorizedFeatures = features.reduce((acc, feature) => {
//     if (!acc[feature.category]) {
//       acc[feature.category] = [];
//     }
//     acc[feature.category].push(feature);
//     return acc;
//   }, {});

//   return (
//     <MainLayout>
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
//         <div className="mb-8">
//           <h1 className="text-3xl font-bold text-gray-900 mb-2">
//             Project Configuration - ID: {projectId}
//           </h1>
//           <p className="text-gray-600">
//             Configure and manage your project settings and features
//           </p>
//         </div>

//         {error && (
//           <div className="bg-red-50 text-red-700 px-4 py-3 rounded-md mb-6">
//             {error}
//           </div>
//         )}

//         {Object.entries(categorizedFeatures).map(
//           ([category, categoryFeatures]) => (
//             <div key={category} className="mb-8">
//               <h2 className="text-xl font-semibold text-gray-800 mb-4">
//                 {category}
//               </h2>
//               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//                 {categoryFeatures.map((feature) => (
//                   <FeatureCard
//                     key={feature.path}
//                     title={feature.title}
//                     description={feature.description}
//                     onClick={() => navigate(`/${feature.path}`)}
//                     status={featureData[feature.title]?.status}
//                     data={featureData[feature.title]?.data}
//                     isLoading={isLoading}
//                   />
//                 ))}
//               </div>
//             </div>
//           )
//         )}
//       </div>
//     </MainLayout>
//   );
// };

// export default ProjectEdit;
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { MainLayout } from "../layout/MainLayout";
import { 
  Settings, 
  Box, 
  Wind, 
  Zap, 
  BarChart3, 
  Database, 
  Leaf, 
  Shield, 
  Play, 
  CheckCircle, 
  AlertCircle, 
  Loader, 
  ArrowRight,
  Edit,
  Home,
  Sun,
  Thermometer
} from "lucide-react";

// Reusable Components
const PageHeader = ({ 
  icon: Icon, 
  title, 
  subtitle, 
  iconGradient = "from-blue-600 to-indigo-600"
}) => (
  <div className="text-center mb-8">
    <div className={`inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br ${iconGradient} rounded-xl mb-4 shadow-lg`}>
      <Icon className="w-8 h-8 text-white" />
    </div>
    <h1 className="text-3xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent mb-3">
      {title}
    </h1>
    <p className="text-base text-slate-600 max-w-2xl mx-auto">
      {subtitle}
    </p>
  </div>
);

const CategorySection = ({ title, icon: Icon, gradient, children }) => (
  <div className="mb-8">
    <div className="bg-white rounded-xl shadow-lg border border-slate-200 overflow-hidden">
      <div className={`bg-gradient-to-r ${gradient} p-4 relative overflow-hidden`}>
        <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent"></div>
        <div className="relative z-10 flex items-center gap-3">
          <Icon className="w-5 h-5 text-white" />
          <h2 className="text-xl font-bold text-white">{title}</h2>
        </div>
        
        {/* Decorative Elements */}
        <div className="absolute -top-4 -right-4 w-12 h-12 bg-white/10 rounded-full"></div>
        <div className="absolute -bottom-2 -left-2 w-8 h-8 bg-white/10 rounded-full"></div>
      </div>
      
      <div className="p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {children}
        </div>
      </div>
    </div>
  </div>
);

const FeatureCard = ({
  title,
  description,
  onClick,
  status,
  data,
  isLoading,
  icon: Icon
}) => {
  const getStatusConfig = () => {
    if (isLoading) {
      return {
        color: "border-slate-300",
        bgColor: "bg-slate-50",
        textColor: "text-slate-600",
        icon: <Loader className="w-4 h-4 animate-spin" />,
        label: "Loading..."
      };
    }
    
    if (status === "active") {
      return {
        color: "border-emerald-400",
        bgColor: "bg-emerald-50",
        textColor: "text-emerald-700",
        icon: <CheckCircle className="w-4 h-4" />,
        label: data ? `Configured - ${data}` : "Configured"
      };
    }
    
    return {
      color: "border-amber-400",
      bgColor: "bg-amber-50",
      textColor: "text-amber-700",
      icon: <AlertCircle className="w-4 h-4" />,
      label: "Not configured"
    };
  };

  const statusConfig = getStatusConfig();

  return (
    <div
      onClick={onClick}
      className={`group bg-white rounded-xl shadow-lg border-2 ${statusConfig.color} overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer`}
    >
      {/* Header */}
      <div className={`${statusConfig.bgColor} p-4 relative overflow-hidden`}>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            {Icon && (
              <div className="p-2 bg-white/80 rounded-lg">
                <Icon className="w-5 h-5 text-slate-700" />
              </div>
            )}
            <div>
              <h3 className="font-bold text-slate-800 group-hover:text-blue-600 transition-colors duration-200">
                {title}
              </h3>
            </div>
          </div>
          <ArrowRight className="w-5 h-5 text-slate-400 group-hover:text-blue-500 group-hover:translate-x-1 transition-all duration-200" />
        </div>
      </div>

      {/* Content */}
      <div className="p-4">
        <p className="text-sm text-slate-600 leading-relaxed mb-4">
          {description}
        </p>
        
        {/* Status */}
        <div className={`flex items-center gap-2 ${statusConfig.textColor} text-sm font-medium`}>
          {statusConfig.icon}
          {statusConfig.label}
        </div>
      </div>

      {/* Hover Glow Effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-600/0 via-indigo-600/0 to-blue-600/0 group-hover:from-blue-600/5 group-hover:via-indigo-600/5 group-hover:to-blue-600/5 transition-all duration-300 pointer-events-none rounded-xl"></div>
    </div>
  );
};

const ErrorState = ({ message }) => (
  <div className="bg-white rounded-xl shadow-lg border border-slate-200 overflow-hidden mb-6">
    <div className="bg-gradient-to-r from-red-500 to-pink-600 p-4 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent"></div>
      <div className="relative z-10 flex items-center gap-3">
        <AlertCircle className="w-5 h-5 text-white" />
        <h2 className="text-xl font-bold text-white">Error</h2>
      </div>
      
      {/* Decorative Elements */}
      <div className="absolute -top-4 -right-4 w-12 h-12 bg-white/10 rounded-full"></div>
      <div className="absolute -bottom-2 -left-2 w-8 h-8 bg-white/10 rounded-full"></div>
    </div>
    
    <div className="p-6">
      <p className="text-slate-600">{message}</p>
    </div>
  </div>
);

const AuthError = () => (
  <div className="bg-white rounded-xl shadow-lg border border-slate-200 overflow-hidden max-w-md mx-auto">
    <div className="bg-gradient-to-r from-orange-500 to-amber-600 p-4 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent"></div>
      <div className="relative z-10 flex items-center gap-3">
        <Shield className="w-5 h-5 text-white" />
        <h2 className="text-xl font-bold text-white">Authentication Required</h2>
      </div>
      
      {/* Decorative Elements */}
      <div className="absolute -top-4 -right-4 w-12 h-12 bg-white/10 rounded-full"></div>
      <div className="absolute -bottom-2 -left-2 w-8 h-8 bg-white/10 rounded-full"></div>
    </div>
    
    <div className="p-6 text-center">
      <p className="text-slate-600">Please log in to access this page</p>
    </div>
  </div>
);

const ProjectEdit = () => {
  const navigate = useNavigate();
  const { projectId } = useParams();
  const [featureData, setFeatureData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("token");

  const features = [
    {
      title: "Project Information",
      description: "Configure basic project settings and general information",
      path: `project/${projectId}`,
      category: "Setup",
      icon: Home
    },
    {
      title: "3D Scene Setup",
      description: "Upload and configure 3D models and scene parameters",
      path: `scene-setup/${projectId}`,
      category: "Setup",
      icon: Box
    },
    {
      title: "Window Configuration",
      description: "Define and manage window properties and positions",
      path: `window-setup/${projectId}`,
      category: "Setup",
      icon: Settings
    },
    {
      title: "Virtual Sensors",
      description: "Configure virtual sensors for environmental monitoring",
      path: `virtual-sensor-setup/${projectId}`,
      category: "Simulation",
      icon: BarChart3
    },
    {
      title: "Sensor Placement",
      description: "Define optimal sensor locations and coverage areas",
      path: `sensor-placement/${projectId}`,
      category: "Simulation",
      icon: Settings
    },
    {
      title: "Wind Gif Simulation",
      description: "Set up and manage wind Gif simulation parameters",
      path: `wind-gif/${projectId}`,
      category: "Simulation",
      icon: Wind
    },
    {
      title: "Wind Analysis",
      description: "Set up and manage wind simulation parameters",
      path: `virtual-wind/${projectId}`,
      category: "Simulation",
      icon: Wind
    },
    {
      title: "Solar Panel Setup",
      description: "Configure PV panels and solar analysis settings",
      path: `pv-panel-setup/${projectId}`,
      category: "Energy",
      icon: Sun
    },
    {
      title: "Room Heat Mapping",
      description: "Set up thermal analysis and heat distribution",
      path: `room-new/${projectId}`,
      category: "Analysis",
      icon: Thermometer
    },
    {
      title: "Building Profile",
      description: "Update building profile information and files",
      path: `file-manager/${projectId}`,
      category: "Data",
      icon: Database
    },
    {
      title: "Technical Data",
      description: "Configure technical specifications and parameters",
      path: `technical-data/${projectId}`,
      category: "Data",
      icon: Database
    },
    {
      title: "CRREM Data",
      description: "Set up Carbon Risk Real Estate Monitor data",
      path: `crrem-data-setup/${projectId}`,
      category: "Sustainability",
      icon: Leaf
    },
    {
      title: "Wind Risk Analysis",
      description: "Configure wind risk assessment parameters",
      path: `wind-risk/${projectId}`,
      category: "Risk Assessment",
      icon: Shield
    },
    {
      title: "Modernization and Financial Dashboard Analysis",
      description: "Configure financial assessment and modernization parameters",
      path: `modernization/${projectId}`,
      category: "Risk Assessment",
      icon: BarChart3
    },
    {
      title: "Shading Analysis",
      description: "Set up shading progression analysis",
      path: `shading-progression/${projectId}`,
      category: "Analysis",
      icon: Sun
    },
    {
      title: "Execution",
      description: "Configure your execution pipeline",
      path: `project-processing/${projectId}`,
      category: "Analysis",
      icon: Play
    },
    {
      title: "Energy Dashboard",
      description: "Configure energy monitoring dashboard",
      path: `energy-dashboard-setup/${projectId}`,
      category: "Energy",
      icon: Zap
    },
  ];

  const categoryConfig = {
    "Setup": { 
      gradient: "from-blue-600 to-indigo-600", 
      icon: Settings 
    },
    "Simulation": { 
      gradient: "from-indigo-600 to-purple-600", 
      icon: Wind 
    },
    "Energy": { 
      gradient: "from-amber-500 to-orange-600", 
      icon: Zap 
    },
    "Analysis": { 
      gradient: "from-emerald-500 to-green-600", 
      icon: BarChart3 
    },
    "Data": { 
      gradient: "from-slate-600 to-slate-700", 
      icon: Database 
    },
    "Sustainability": { 
      gradient: "from-green-600 to-emerald-600", 
      icon: Leaf 
    },
    "Risk Assessment": { 
      gradient: "from-orange-500 to-red-500", 
      icon: Shield 
    }
  };

  useEffect(() => {
    const fetchFeatureStatuses = async () => {
      setIsLoading(true);
      try {
        const apiRoot = process.env.REACT_APP_API_ROOT;
        const statuses = {};

        for (const feature of features) {
          try {
            const response = await fetch(
              `${apiRoot}/api/feature-status/${feature.path}`
            );
            const data = await response.json();
            statuses[feature.title] = {
              status: data.isConfigured ? "active" : "inactive",
              data: data.summary,
            };
          } catch {
            statuses[feature.title] = {
              status: "inactive",
              data: null,
            };
          }
        }
        setFeatureData(statuses);
      } catch (err) {
        setError("Failed to load feature statuses");
      } finally {
        setIsLoading(false);
      }
    };

    if (token && projectId) {
      fetchFeatureStatuses();
    }
  }, [token, projectId]);

  if (!token) {
    return (
      <MainLayout>
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex items-center justify-center p-6">
          <AuthError />
        </div>
      </MainLayout>
    );
  }

  const categorizedFeatures = features.reduce((acc, feature) => {
    if (!acc[feature.category]) {
      acc[feature.category] = [];
    }
    acc[feature.category].push(feature);
    return acc;
  }, {});

  return (
    <MainLayout>
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 p-6">
        <div className="max-w-7xl mx-auto">
          
          <PageHeader
            icon={Edit}
            title={`Project Configuration`}
            subtitle={`Configure and manage your project settings and features for Project ID: ${projectId}`}
          />

          {error && <ErrorState message={error} />}

          {Object.entries(categorizedFeatures).map(([category, categoryFeatures]) => {
            const config = categoryConfig[category] || { 
              gradient: "from-slate-600 to-slate-700", 
              icon: Settings 
            };
            
            return (
              <CategorySection
                key={category}
                title={category}
                icon={config.icon}
                gradient={config.gradient}
              >
                {categoryFeatures.map((feature) => (
                  <FeatureCard
                    key={feature.path}
                    title={feature.title}
                    description={feature.description}
                    onClick={() => navigate(`/${feature.path}`)}
                    status={featureData[feature.title]?.status}
                    data={featureData[feature.title]?.data}
                    isLoading={isLoading}
                    icon={feature.icon}
                  />
                ))}
              </CategorySection>
            );
          })}
        </div>
      </div>
    </MainLayout>
  );
};

export default ProjectEdit;